import React from 'react'
import update from 'immutability-helper'
import PropTypes from 'prop-types'
import shortid from 'shortid'
import { midas } from '@resurs/midas'
import { NumberInput, TextInput } from '@resurs/midas-react'
import styles from './order.style'
import { parseUnitPriceExVat } from '../../../../../util/helpers'

const getVatSum = state => {
  return ((state.quantity * state.unitPriceExVat) / 100) * state.vat
}

const getSum = state => {
  const itemVatSum = getVatSum(state)
  return itemVatSum + state.quantity * state.unitPriceExVat
}

class OrderLine extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      articleNbr: this.props.line.articleNbr,
      description: this.props.line.description,
      quantity: this.props.line.quantity,
      unitPriceExVat: this.props.line.unitPriceExVat,
      vat: this.props.line.vat,
      sum: this.props.line.sum,
    }
  }

  onChange(newState) {
    const summaryState = {
      ...newState,
      sum: getSum(newState),
      vatSum: getVatSum(newState),
    }
    this.setState(summaryState)
    this.props.onChange(summaryState)
  }

  render() {
    const lineId = shortid.generate()

    return (
      <div style={styles.table} className={`${midas.columns}`}>
        <div
          style={styles.tableCell}
          className={`${midas.column} ${midas.col2}`}
        >
          <TextInput
            id="articleNbr"
            label=""
            skipValidation
            onChange={e => {
              this.onChange(
                update(this.state, {
                  articleNbr: { $set: e.target.value },
                }),
              )
            }}
            value={this.state.articleNbr || ''}
          />
        </div>
        <div
          style={styles.tableCell}
          className={`${midas.column} ${midas.col3}`}
        >
          <TextInput
            id="description"
            label=""
            skipValidation
            onChange={e => {
              this.onChange(
                update(this.state, {
                  description: { $set: e.target.value },
                }),
              )
            }}
            value={this.state.description || ''}
          />
        </div>
        <div
          style={styles.tableCell}
          className={`${midas.column} ${midas.col1}`}
        >
          <TextInput
            id="quantity"
            label=""
            skipValidation
            onChange={e => {
              this.onChange(
                update(this.state, {
                  quantity: { $set: e.target.value },
                }),
              )
            }}
            type="number"
            value={this.state.quantity || ''}
          />
        </div>
        <div
          style={styles.tableCell}
          className={`${midas.column} ${midas.col2}`}
        >
          <NumberInput
            id="unitPriceExVat"
            label=""
            skipValidation
            allowNegative
            onChange={number => {
              this.onChange(
                update(this.state, {
                  unitPriceExVat: {
                    $set: parseUnitPriceExVat(number),
                  },
                }),
              )
            }}
            value={this.state.unitPriceExVat || ''}
          />
        </div>
        <div
          style={styles.tableCell}
          className={`${midas.column} ${midas.col1}`}
        >
          <TextInput
            id="vat"
            label=""
            skipValidation
            onChange={e => {
              this.onChange(
                update(this.state, {
                  vat: { $set: e.target.value },
                }),
              )
            }}
            type="number"
            value={this.state.vat || ''}
          />
        </div>
        <div
          style={styles.innerTableCell}
          className={`${midas.column} ${midas.col3}`}
        >
          <div style={styles.innerTable} className={`${midas.columns}`}>
            <div
              style={styles.tableAmountCell}
              className={`${midas.column} ${midas.col6}`}
            >
              <NumberInput
                tabIndex="-1"
                id="sum"
                key={`sum_${lineId}`}
                label=""
                readonly
                skipValidation
                value={this.state.sum ? this.state.sum.toFixed(2) : ''}
              />
            </div>
            <div
              style={styles.tableAmountCell}
              className={`${midas.column} ${midas.col6}`}
            >
              <NumberInput
                tabIndex="-1"
                id="vatSum"
                key={`vatSum_${lineId}`}
                label=""
                readonly
                skipValidation
                value={this.state.vatSum ? this.state.vatSum.toFixed(2) : ''}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

OrderLine.propTypes = {
  line: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default OrderLine
